cdb.config.set('assets_url', '//cartodb-libs.global.ssl.fastly.net/cartodbui/assets/3.24.10');
console.log('cartodbui v3.24.10');